"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialNetworkLinkValid = exports.normalizeSocialNetworkUrl = exports.isSocialNetworkBaseUrl = exports.getSocialNetworkBaseUrl = exports.isSocialNetworkPlatform = exports.SOCIAL_NETWORK_PLATFORMS = void 0;
exports.SOCIAL_NETWORK_PLATFORMS = ["Facebook", "X", "YouTube", "Instagram", "LinkedIn", "TikTok"];
const SOCIAL_NETWORK_HOSTS = {
    Facebook: ["facebook.com", "fb.com", "fb.me"],
    X: ["x.com", "twitter.com"],
    YouTube: ["youtube.com", "youtu.be"],
    Instagram: ["instagram.com"],
    LinkedIn: ["linkedin.com"],
    TikTok: ["tiktok.com"],
};
const isSocialNetworkPlatform = (platform) => exports.SOCIAL_NETWORK_PLATFORMS.includes(platform);
exports.isSocialNetworkPlatform = isSocialNetworkPlatform;
const getSocialNetworkBaseUrl = (platform) => `https://${SOCIAL_NETWORK_HOSTS[platform][0]}/`;
exports.getSocialNetworkBaseUrl = getSocialNetworkBaseUrl;
const isSocialNetworkBaseUrl = (platform, url) => url.trim().replace(/\/+$/, "") === (0, exports.getSocialNetworkBaseUrl)(platform).replace(/\/+$/, "");
exports.isSocialNetworkBaseUrl = isSocialNetworkBaseUrl;
const parseUrl = (url) => {
    try {
        return new URL(url);
    }
    catch {
        return null;
    }
};
const normalizeSocialNetworkUrl = (url) => {
    const trimmedUrl = url.trim();
    const urlWithProtocol = /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
    return parseUrl(urlWithProtocol)?.href ?? urlWithProtocol;
};
exports.normalizeSocialNetworkUrl = normalizeSocialNetworkUrl;
const isSocialNetworkLinkValid = (platform, url) => {
    const parsedUrl = parseUrl((0, exports.normalizeSocialNetworkUrl)(url));
    if (!parsedUrl) {
        return false;
    }
    const { hostname, pathname } = parsedUrl;
    const host = hostname.toLowerCase();
    const isPlatformHost = SOCIAL_NETWORK_HOSTS[platform].some((platformHost) => host === platformHost || host.endsWith(`.${platformHost}`));
    return isPlatformHost && pathname.replace(/\/+$/, "").length > 0;
};
exports.isSocialNetworkLinkValid = isSocialNetworkLinkValid;
